import { render, staticRenderFns } from "./NavTreeRoot.vue?vue&type=template&id=20d43868&"
import script from "./NavTreeRoot.vue?vue&type=script&lang=js&"
export * from "./NavTreeRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports